module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/carton4.400a972e.jpg";